// extracted by mini-css-extract-plugin
module.exports = {"reverse":"about_reverse__3b8SN","container":"about_container__5Uz_w","logo":"about_logo__mIO1X","body":"about_body__3Eo99","link":"about_link__3rU_E"};